/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorServiceNeedsTypename = "PharmacyCounselorServiceNeeds" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorServiceNeeds
 */
export interface PharmacyCounselorServiceNeeds {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorServiceNeeds
   */
  communication?: PharmacyCounselorServiceNeedsCommunicationEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorServiceNeeds
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorServiceNeedsCommunicationEnum {
  Normal = "normal",
  Careful = "careful",
}

export function PharmacyCounselorServiceNeedsFromJSON(json: any): PharmacyCounselorServiceNeeds {
  return PharmacyCounselorServiceNeedsFromJSONTyped(json, false);
}

export function PharmacyCounselorServiceNeedsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorServiceNeeds {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorServiceNeedsTypename,

    communication: !exists(json, "communication") ? undefined : json["communication"],
  };
}

export function PharmacyCounselorServiceNeedsToJSON(object?: PharmacyCounselorServiceNeeds | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    communication: value.communication,
  };
}
